import validate from "/var/lib/jenkins/workspace/oh0t/landry/portal/src_bfd5ad77/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/var/lib/jenkins/workspace/oh0t/landry/portal/src_bfd5ad77/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}